import React from "react";
import { contactDetails } from "../data/contact";
export function ContactBar() {
  return <footer className="border-t border-brand-white/10 bg-brand-charcoal/80 px-6 py-4 sm:px-10 lg:px-16" data-id="element-8" data-mp="27e2y6j37yxd1">
      <address className="flex flex-col gap-2.5 not-italic sm:flex-row sm:flex-wrap sm:items-center sm:gap-x-8 sm:gap-y-2" data-id="element-9" data-mp="2cdfudufzdgsa">
        {contactDetails.map(item => {
        const Icon = item.icon;
        const content = <>
              <Icon className="h-4 w-4 shrink-0 text-brand-red" strokeWidth={1.75} aria-hidden="true" data-id="element-10" data-mp="2m9smwozsholg" />
              <span className="whitespace-nowrap" data-id="element-11" data-mp="2qbdt5rhtj4mo">{item.value}</span>
            </>;
        return item.href ? <a key={item.id} href={item.href} aria-label={`${item.label}: ${item.value}`} className="flex items-center gap-2 text-[13px] text-brand-white/80 transition-colors duration-150 hover:text-brand-white focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-white" data-id="element-12" data-mp="3030g2l3iqs59">
              {content}
            </a> : <span key={item.id} className="flex items-center gap-2 text-[13px] text-brand-white/80" data-id="element-13" data-mp="3upkzw9jqyb89">
              {content}
            </span>;
      })}
      </address>
    </footer>;
}